import { Link } from "eddev/routing"
import { AwardEntryCardFragment } from "../../types.graphql"
import { RouteFlipped } from "@components/motion/RouteFlipped"
import { ResponsiveImage } from "@components/atoms/ResponsiveImage"
import { ChipList } from "@components/layout/ChipList"

type Props = AwardEntryCardFragment

export function AwardEntryCard(props: Props) {
  return (
    <Link href={props.uri} className="block mb-7 group">
      <div className="w-full">
        {!!props.hero?.srcSet && (
          <RouteFlipped flipId={props.id!}>
            <ResponsiveImage fadeOnLoad={false} srcSet={props.hero?.srcSet} aspect={props.hero?.aspect!} />
          </RouteFlipped>
        )}
      </div>
      <div className="stack-y-1 pt-2">
        <div className="stack-y-2">
          <div className="type-title-xs-medium md:type-title-s-medium antialiased text-pretty group-hover:text-grey-dark">{props.title}</div>
          <ChipList
            noLinks
            chips={[
              {
                label: String(props.year),
              },
              {
                label: props.category?.parent?.title!,
              },
              {
                label: props.merit!,
              },
              {
                label: props.studio?.name!,
              },
            ].filter((c) => !!c.label)}
          />
        </div>
        <div className="type-body-s-roman">{props.category?.title}</div>
      </div>
    </Link>
  )
}
